import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { FeedbackFormCreate } from './FeedbackFormCreate';
import { FeedbackFormDisplay } from './FeedbackFormDisplay';
import { FeedbackFormSearch } from './FeedbackFormSearch';
import { FeedbackFormUpdate } from './FeedbackFormUpdate';
import { Four04 } from 'gossamer-front-end';
import { EventFeedbackDisplay } from './EventFeedbackDisplay';

export const FeedbackFormRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/create" element={<FeedbackFormCreate />} />
    <Route path="/display/:key" element={<FeedbackFormDisplay />} />
    <Route path="/event-feedback-display/:key" element={<EventFeedbackDisplay />} />
    <Route path="/search" element={<FeedbackFormSearch />} />
    <Route path="/update/:key" element={<FeedbackFormUpdate />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
